export const CLE_UNI_SEARCH_SLUG = 'clearing-universities';
